export default "__VITE_ASSET__oEOTYVbm__"